module.exports = __webpack_public_path__ + "img/espa_el.b64fac73.jpg";